import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import theme from 'theme';

export const ModalCustomStyle = {
    maxWidth: '1500px',
};

export const ModalBodyWrapper = styled.div`
    font-family: 'Graphik', helvetica;
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const ButtonGroupWrapper = styled.div`
    align-self: flex-end;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    padding: 8px;
`;

export const ButtonWrapper = styled.div`
    padding: 20px;
    margin-left: auto;
    display: flex;
    align-items: right;
    justify-content: right;
    width: 100%;
    box-sizing: border-box;
`;

export const WarningContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0px;
    background-color: ${theme.buttermilk};
    border: 1px solid ${theme.lightGrey};
`;

export const WarningText = styled.span`
    color: ${theme.sherpaBlue};
    text-align: center;
    font-size: 14px;
`;

export const BoldWarning = styled.span`
    font-weight: 500;
    color: ${theme.greyOnYellow};
`;

export const BoldText = styled.span`
    font-weight: 500;
`;

export const WarningIcon = styled(FontAwesomeIcon).attrs({
    icon: faExclamationCircle,
})`
    color: ${theme.greyOnYellow};;
    margin-right: 5px;
`;

export const RowScroller = styled.div`
    position: relative;
    max-height: 390px;
    overflow-y: auto;
    border-bottom: 1px solid ${theme.lightGrey};

    @media (max-height: 700px) {
        max-height: 300px;
    }
    @media (max-height: 600px) {
        max-height: 250px;
    }
    @media (max-height: 550px) {
        max-height: 200px;
    }
    @media (max-height: 500px) {
        max-height: 150px;
    }
`;

export const ContentWithOverlay = styled.div`
    position: relative;
    min-height: 100%;
`;

export const FixedContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const ConfirmText = styled.span`
    color: ${theme.sherpaBlue};
    text-align: center;
    font-size: 14px;
    padding: 7px;
`;

export const ConfirmInputWrapper = styled.div`
    margin-right: 10px;
    input {
        padding: 8px;
        margin-right: 20px;
        border: 1px solid ${theme.sherpaBlue};
        color: ${theme.sherpaBlue};
    }

    input:focus {
        border-color: ${theme.sherpaBlue};
        outline: none;
    }
`;
